import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';

export interface StaticListItem {
  id: number;
  title: string;
  slug: string;
}

export const key = ['STATIC_LIST'];

export const useGetStaticList = () => {
  return useQuery(key, async (): Promise<StaticListItem[]> => {
    const { data } = await axiosInstance.get('/api/get-public-static-pages');
    return data;
  });
};
